import script from "./TariffFaq.vue?vue&type=script&setup=true&lang=js"
export * from "./TariffFaq.vue?vue&type=script&setup=true&lang=js"

import "./TariffFaq.vue?vue&type=style&index=0&id=090f2c08&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-090f2c08"]])

export default __exports__